import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineWalletIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 7h-1V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3ZM5 5h10a1 1 0 0 1 1 1v1H5a1 1 0 0 1 0-2Zm15 10h-1a1.0001 1.0001 0 0 1 0-2h1v2Zm0-4h-1a3 3 0 0 0 0 6h1v1a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V8.83c.3213.113.6594.1705 1 .17h14a1 1 0 0 1 1 1v1Z"/>
  </SvgIcon>
}

export default LineWalletIcon
